import {
  CATEGORY_LIQUID_COLORS,
  EFFECT_LIQUID_COLORS,
  EMPTY_LIQUID_COLOR,
  FRIGHTENING_EFFECTS,
  KID_EXPRESSIONS,
} from '../constants/effects';
import { MIX_PHASES } from '../constants/labPhases';

/**
 * What a flask in the kid's hand shows for a picked substance (or nothing picked).
 */
export function getFlaskAppearance(substance) {
  if (!substance) return { label: '?', liquidColor: EMPTY_LIQUID_COLOR };
  return { label: substance.symbol, liquidColor: CATEGORY_LIQUID_COLORS[substance.category] };
}

export function getBeakerLiquidColor(reaction, mixPhase) {
  if (!reaction || mixPhase === MIX_PHASES.IDLE) return EMPTY_LIQUID_COLOR;
  return EFFECT_LIQUID_COLORS[reaction.effect];
}

/**
 * Fizzy looks frightened while a pop/bang reaction plays, and happy the rest of the time.
 */
export function getKidExpression(reaction, mixPhase) {
  const isPopPlaying = mixPhase === MIX_PHASES.PLAYING && reaction && FRIGHTENING_EFFECTS.includes(reaction.effect);
  return isPopPlaying ? KID_EXPRESSIONS.FRIGHTENED : KID_EXPRESSIONS.HAPPY;
}
